import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { FaSearch, FaTimes, FaChevronDown } from 'react-icons/fa';
import './FiltroImoveis.css';

const defaultFilters = {
  id: '',
  numero_contribuinte: '',
  logradouro: '',
  numero: '',
  bairro: '',
  referencia: '',
  cep: '',
  status: '',
  condominio: '',
  processamento: '',
  etiqueta_id: ''
};

const FilterField = ({ name, label, value, onChange, placeholder, as = 'input', options = [] }) => {
  return (
    <div className={`filter-field filter-${name}`}>
      <label htmlFor={name}>{label}</label>
      {as === 'select' ? (
        <select
          id={name}
          name={name}
          value={value}
          onChange={onChange}
        >
          {options.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      ) : (
        <input
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
        />
      )}
    </div>
  );
};

export default function FiltroImoveis({ onSearch }) {
  const [isOpen, setIsOpen] = useState(false);
  const [filters, setFilters] = useState(defaultFilters);
  const [etiquetas, setEtiquetas] = useState([]);

  useEffect(() => {
    api.get('/etiquetas').then(response => {
      setEtiquetas(response.data);
    }).catch(error => {
      console.error("Erro ao buscar etiquetas", error);
    });
  }, []);

  const etiquetaOptions = [
    { value: '', label: 'Todas' },
    ...etiquetas.map(e => ({ value: e.id, label: e.nome }))
  ];

  const statusOptions = [
    { value: '', label: 'Todos' },
    { value: 'Ativo', label: 'Ativo' },
    { value: 'Negociação', label: 'Negociação' },
    { value: 'Inativo', label: 'Inativo' },
  ];

  const handleChange = e => {
    const { name, value } = e.target;
    setFilters(f => ({ ...f, [name]: value }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    onSearch(filters);
  };

  const handleReset = () => {
    setFilters(defaultFilters);
    onSearch(defaultFilters);
  };

  return (
    <div className="filter-accordion">
      <button className="filter-accordion-header" onClick={() => setIsOpen(!isOpen)}>
        <span>Filtros de Pesquisa</span>
        <FaChevronDown className={`chevron-icon ${isOpen ? 'open' : ''}`} />
      </button>
      {isOpen && (
        <div className="filter-accordion-content">
          <form className="filtro-imoveis-form" onSubmit={handleSubmit}>
            <div className="filters-grid">
              <FilterField name="id" label="ID" value={filters.id} onChange={handleChange} placeholder="1" />
              <FilterField name="numero_contribuinte" label="Contribuinte" value={filters.numero_contribuinte} onChange={handleChange} placeholder="123456" />
              <FilterField name="logradouro" label="Logradouro" value={filters.logradouro} onChange={handleChange} placeholder="Rua ABC" />
              <FilterField name="numero" label="Número" value={filters.numero} onChange={handleChange} placeholder="123" />
              <FilterField name="bairro" label="Bairro" value={filters.bairro} onChange={handleChange} placeholder="Centro" />
              <FilterField name="referencia" label="Referência" value={filters.referencia} onChange={handleChange} placeholder="Próximo ao mercado" />
              <FilterField name="cep" label="CEP" value={filters.cep} onChange={handleChange} placeholder="12345-678" />
              <FilterField name="condominio" label="Condomínio" value={filters.condominio} onChange={handleChange} placeholder="Condomínio X" />
              <FilterField name="processamento" label="Proc. Origem" value={filters.processamento} onChange={handleChange} placeholder="1" />
              <FilterField name="status" label="Status" value={filters.status} onChange={handleChange} as="select" options={statusOptions} />
              <FilterField name="etiqueta_id" label="Etiqueta" value={filters.etiqueta_id} onChange={handleChange} as="select" options={etiquetaOptions} />
            </div>

            <div className="filter-actions">
              <button type="submit" className="button-primary">
                <FaSearch />
                <span>Buscar</span>
              </button>
              <button type="button" className="button-secondary" onClick={handleReset}>
                <FaTimes />
                <span>Limpar</span>
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}